export const storeDatabaseCompanies = (data) => {
    return {
      type: "storeDatabaseCompanies",
      payload: data,
    };
  };